import React from 'react';
import DataTablesContainer from '../../Componant/Tables/DataTable';

const DataTable = () => {
  return (
    <div className='page-body'>
      <DataTablesContainer />
    </div>
  );
};

export default DataTable;
